export default __webpack_public_path__ + "static/media/MaterialMetal_06.f950faca.png";